import ctHelpHelper from '@/scripts/crossTabulation/helpHelper';
import ctHelpText from '@/scripts/crossTabulation/helpText';
import ctModelHelper from '@/scripts/crossTabulation/modelHelper'
import ctNavigation from '@/scripts/crossTabulation/navigation';
import ctTestHelper from '@/scripts/crossTabulation/testHelper';
import ctSelectionModel from '@/data/crossTabulationSelectionModel';

import lrHelpHelper from '@/scripts/logisticRegression/helpHelper';
import lrHelpText from '@/scripts/logisticRegression/helpText';
import lrModelHelper from '@/scripts/logisticRegression/modelHelper'
import lrNavigation from '@/scripts/logisticRegression/navigation';
import lrTestHelper from '@/scripts/logisticRegression/testHelper';
import lrSelectionModel from '@/data/logisticRegressionSelectionModel';
import store from '@/store';
import commonModelHelper from '@/scripts/commonModelHelper';
import metricsHelper from "@/scripts/metricsHelper";
// import ctXlsxBuilder from "@/scripts/crossTabulation/xlsxBuilder";
// import lrXlsxBuilder from "@/scripts/logisticRegression/xlsxBuilder";


const shortSplashDescription = 'The BRFSS, the world\'s largest continuously conducted telephone health survey, tracks health risks in the United States.Information from the survey is used to improve the health of US residents.';
const longSplashDescription = 'The BRFSS is the world\'s largest telephone health survey system, tracking health risks in the United States. Information from the survey is used to improve the health of US residents. The BRFSS Web Enabled Analysis Tool (WEAT) allows users to conduct real-time state-level data analysis.';


export default {
    shortSplashDescription,
    longSplashDescription,
    //Vue.component('current', {
    //new Vue({
    /*name: 'current',
    data: function () {
      return {
        currentType: null,
        selectionModel: null,
        modelHelper: null,
        helpHelper: null,
        helpText: null,
        navigation: null,
        testHelper: null,
        startingPage: ''
      }
    },*/
    initializeCrossTabulationValues: function (vm) {
        const c = this;
        clearLoading();
        var thisType = 'ct';
        if (vm && vm.$router)
            c.$router = vm.$router;
        if (c.currentType === thisType)
            return;
        c.currentType = thisType;
        c.selectionModel = ctSelectionModel;
        c.modelHelper = ctModelHelper;
        c.helpHelper = ctHelpHelper;
        c.helpText = ctHelpText;
        ctNavigation.initialize();
        c.navigation = ctNavigation;
        c.testHelper = ctTestHelper;
        c.startingPage = '/crossTabulation/selectYear';
        // c.xlsxBuilder = ctXlsxBuilder;
        setTitle('Cross Tabulation');
        commonModelHelper.resetYear();
    },
    initializeLogisticRegressionValues: function (vm) {
        const c = this;
        clearLoading();
        var thisType = 'lr';
        if (vm && vm.$router)
            c.$router = vm.$router;
        if (c.currentType === thisType)
            return;
        c.currentType = thisType;
        c.selectionModel = lrSelectionModel;
        c.modelHelper = lrModelHelper;
        c.helpHelper = lrHelpHelper;
        c.helpText = lrHelpText;
        lrNavigation.initialize();
        c.navigation = lrNavigation;
        c.testHelper = lrTestHelper;
        c.startingPage = '/logisticRegression/selectYear';
        // c.xlsxBuilder = lrXlsxBuilder;
        setTitle('Logistic Regression');
        commonModelHelper.resetYear();

    },
    initializeValidateVariables: function (title) {
        const c = this;
        clearLoading();
        var thisType = 'vv';
        if (c.currentType === thisType)
            return;
        c.currentType = thisType;
        setTitle(title);
        commonModelHelper.resetYear();
    },
    initializeIndex: function () {
        const c = this;
        clearLoading();
        c.currentType = 'analysis';
        setTitle('BRFSS Analysis', longSplashDescription);
        store.dispatch('display/setMenu', { menuGroup: 'analysis', menuItem: 'index' });
        commonModelHelper.resetYear();
    },
    initializeAnalysis: function () {
        const c = this;
        clearLoading();
        c.currentType = 'analysis';
        setTitle('BRFSS Analysis', longSplashDescription);
        store.dispatch('display/setMenu', { menuGroup: 'analysis', menuItem: 'analysis' });
        commonModelHelper.resetYear();
    },
    initializeHelp: function () {
        const c = this;
        clearLoading();
        c.setHelpTitleEtc('BRFSS Web Enabled Analysis Tool Help', '/help');
    },
    initializeDataAnalysisFaq: function () {
        const c = this;
        clearLoading();
        c.setHelpTitleEtc('Data Analysis FAQ', '/userGuide/dataAnalysisFaq');
    },
    initializeCrossTabulationHelp: function () {
        const c = this;
        clearLoading();
        c.setHelpTitleEtc('Cross Tabulation', '/userGuide/crossTabulation');
    },
    initializeLogisticRegressionHelp: function () {
        const c = this;
        clearLoading();
        c.setHelpTitleEtc('Logistic Regression', '/userGuide/logisticRegression');
    },
    initializeVariableHelper: function () {
        const c = this;
        clearLoading();
        c.setHelpTitleEtc('Independent, Dependent and Control Variables', '/userGuide/variables');
    },
    setHelpTitleEtc,
    resetClicked
}

function clearLoading() {
    store.dispatch('display/setIsLoading', false);
}

function setHelpTitleEtc(title, url) {
    const c = this;
    c.currentType = 'help';
    setTitle(title, longSplashDescription);
    store.dispatch('display/setBreadCrumbs', [
        { url: '/help', title: 'Help' },
        { url: url, title: title }
    ]);
    store.dispatch('display/setMenu', { menuGroup: 'Help', menuItem: url });
    commonModelHelper.resetYear();
}


function setTitle(pageTitle, splashDescription) {
    store.dispatch('display/setTitle', { pageTitle, splashDescription });
}

function resetClicked(e) {
    const c = this;
    if (e)
        e.preventDefault();
    metricsHelper.reset();
    c.modelHelper.resetAllValues();
    c.$router.push({ path: c.startingPage });
}